import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';

export namespace NModalLayout {
    type TInjectionFn = (sizeName: ISizeName) => Partial<ModalConfig>;
    type TInjection = Partial<ModalConfig> | TInjectionFn;

    export namespace Bottom {
        /**
         * Default setup for left side modal
         */
        export const baseModalConfig: ModalConfig = {
            closeOnNavigation: true,
            minWidth: '100vw',
            height: '78vh',
            maxWidth: undefined,
            position: {
                bottom: '0',
                right: '0'
            },
            transformOptions: `translate3d(0px, 100%, 0px)`,
            transitionOptions: '500ms ease-in-out',
            modalClass: 'p-a-0',
            hasBackdrop: true
        };

        export const modalConfig = (inject?: TInjection) => {
            return sizeName => ({
                ...baseModalConfig,
                ...(typeof inject === 'function' ? inject(sizeName) : inject)
            });
        };
    }

    export namespace Right {
        /** we need a functiojn here cuase app is not yet ready to generate vw classes when const is set */
        export const getWidth = (size: ISizeName): string =>
            ({ S: StylesService.vw(100), M: StylesService.vw(72), L: '467px', X: '467px' })[size];

        /**
         * Default setup for right side modal
         */
        export const baseModalConfig: ModalConfig = {
            closeOnNavigation: true,
            height: '100vh',
            maxWidth: undefined,
            transformOptions: `translate3d(100%, 0px, 0px)`,
            modalClass: 'p-a-0',
            position: {
                top: '0',
                bottom: '0',
                right: '0'
            },
            transitionOptions: '500ms ease-in-out',
            hasBackdrop: true
        };

        export const modalConfig = (inject?: TInjection) => {
            return sizeName => ({
                ...baseModalConfig,
                width: getWidth(sizeName),
                ...(typeof inject === 'function' ? inject(sizeName) : inject)
            });
        };
    }
}

@Component({
    selector: 'modal-layout',
    templateUrl: 'modal-layout.html',
    styleUrls: ['modal-layout.scss'],
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalLayoutComponent {
    @Input()
    modalTitle?: string;

    @Input()
    modalSubtitle?: string;

    /**
     * Dependencies
     */
    constructor(private modalRef: ModalRef<any>) {}

    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }
}
